<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";
import { defineAsyncComponent} from "vue";
// import { defineAsyncComponent, ref } from "vue";
// import moment from "moment";


const TableNilaiIndividu = defineAsyncComponent(async()=>{
  await new Promise((r)=>setTimeout(r,500));
  return import("./tabel-detail-evaluasi-akademik/table-nilai-individu.vue")
});

const TableNilaiQuiz = defineAsyncComponent(async()=>{
  await new Promise((r)=>setTimeout(r,500));
  return import("./tabel-detail-evaluasi-akademik/table-nilai-quiz.vue")
});

const TableNilaiKelompok = defineAsyncComponent(async()=>{
  await new Promise((r)=>setTimeout(r,500));
  return import("./tabel-detail-evaluasi-akademik/table-nilai-kelompok.vue")
});

const TableNilaiSubstansi = defineAsyncComponent(async()=>{
  await new Promise((r)=>setTimeout(r,500));
  return import("./tabel-detail-evaluasi-akademik/table-nilai-substansi.vue")
});

export default {
  page: {
    title: "Detail Nilai Evaluasi Akademik Pelaksanaan",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    TableNilaiIndividu,
    TableNilaiQuiz,
    TableNilaiKelompok,
    TableNilaiSubstansi,
  },
  data() {
    return {
      title: "Detail Nilai Akademik",
      items: [
        {
          text: "Pelaksanaan",
          href: "/",
        },
        {
          text: "Data Pelaksanaan",
          href: "/pra-pelaksanaan/pembelajaran",
        },
        {
          text: "Detail Nilai Akademik",
          active: true,
        },
      ],

      loadingTableSubstansi: false,
      id: this.$route.params.id,
      nomor_surat: null,
      kode: null,
      judul: null,
      dasar_pelaksanaan: null,
      strategi: null,
      strategi_id: null,
      durasi_he: null,
      durasi_jp: null,
      tanggal_mulai: null,
      tanggal_selesai: null,
      learning_type: null,
      angkatan: null,

      templateExcel:'/template_excel/template_nilai_akademik.xlsx',

      showModal:{
        importNilai: false,
      },

      pathExcel:{
        Nilai: null,
      },

      inputIndividu: {
        mahmud: { value: '91,7' },
        yura: { value: '89,35' },
        rahmah: { value: '90,00' }
      },

      inputQuiz: {
        mahmud: { value: '91,7' },
        yura: { value: '89,35' },
        rahmah: { value: '90,00' }
      },

      inputKelompok: {
        mahmud: { value: '91,7' },
        yura: { value: '89,35' },
        rahmah: { value: '90,00' }
      },

      inputSubstansi: {
        mahmud: { value: '91,7' },
        yura: { value: '89,35' },
        rahmah: { value: '90,00' }
      },


      


    };
  },
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    // get data pembelajaran
    var config = {
      method: "get",
      url:
        process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
      params: {
        id: self.id,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };
    axios(config)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          var data_edit = response_data_fix.data_pembelajaran;
          self.nomor_surat = data_edit.pbl_nomor_surat;
          self.kode = data_edit.pbl_kode;
          self.judul = data_edit.pbl_dasar_pelaksanaan;
          self.dasar_pelaksanaan = data_edit.pbl_judul;
          self.strategi = data_edit.pbl_strategi;
          self.strategi_id = data_edit.pbl_strategi_id;
          self.durasi_he = data_edit.pbl_durasi_he;
          self.durasi_jp = data_edit.pbl_durasi_jp;
          self.tanggal_mulai = data_edit.pbl_tgl_mulai;
          self.tanggal_selesai = data_edit.pbl_tgl_selesai;
          self.learning_type = data_edit.pbl_lt_name;
          self.angkatan = data_edit.pbl_angkatan;

          self.pratikum = data_edit.pbl_pratikum;


        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    importNilai(){
      let self = this;
      self.showModal.importNilai = true;
    },
      
    inputFileExcelNilai(){
      let self = this;
      if($("#inputExcelNilai")[0].files[0]){
        let filename = $('#inputExcelNilai')[0].files[0].name;
        let fileExtension = filename.split('.').pop().toLowerCase();

        if(fileExtension === 'xlsx'){
          $("uploadLoadingNilai").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#inputExcelNilai")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            var resStatus = response.status;
            if (resStatus === 200) {
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoadingNilai").html(
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-check"></i>' +
                'Berhasil' +
                '</span>' +
                '<a href="' + urlres + '" target="_blank" style="padding-left:10px;">' +
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-eye"></i>' +
                'Lihat File' +
                '</span>' +
                '</a>'
              );

              self.pathExcel.NilaiIndividu = path_file;
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong !',
                showConfirmButton: true,
              });
            }
          });
        } else {
          alert("Format file harus ber-type (XLSX)");
          $('#inputExcelNilai').val('');
        }
      }
    },

    async storeImportNilai() {
      let self = this;
      
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/import-nilai-akademik",
        data: {
          id: self.id,
          path_excel: self.pathExcel.NilaiIndividu
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token
        }
      };
      
      await axios(config).then(async (response) => {
        var resStatus = response.status;
        if (resStatus == 200) {
          await Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Success upload data !',
            showConfirmButton: true,
          });
          $("#inputExcelNilai").val('');
          $("#uploadLoadingNilai").empty();

          const methods ={
            TableNilaiIndividuRef: 'getDataNilaiIndividu',
            TableNilaiKelompokRef: 'getDataNilaiKelompok',
            TableNilaiQuizRef: 'getDataNilaiQuiz',
            TableNilaiSubstansiRef: 'getDataNilaiSubstansi'
          }

          Object.keys(methods).forEach(ref=>{
            const namaMethods = methods[ref];
            const child = self.$refs[ref];
            if(child && typeof child[namaMethods]=== 'function'){
              child[namaMethods]();
            } 
          });
          
          self.showModal.importNilai = false
          
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong !',
            showConfirmButton: true,
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n ' + error,
          showConfirmButton: true,
        });
      });
    },
    
async exportNilaiAkademik(){
      let self = this;

     Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/eksport-nilai-akademik",
        responseType: 'blob',
        crossdomain: true,
        params: {
          id: self.id
        },
        headers: {
          Accept: "application/vnd.ms-excel",
          Authorization: "Bearer " + localStorage.access_token
        }
      };

    await axios(config).then(async (response) => {
    var resStatus = response.status;
    if (resStatus == 200) {
      Swal.close();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = 'Nilai_Akademik_'+new Date().toISOString().slice(0, 10)+'.xlsx';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();  
        await Swal.fire({
           icon: 'success',
           title: 'Success',
           text: 'The academic data has been exported successfully!',
           showConfirmButton: true,
         });
    } else {
        Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong!',
            showConfirmButton: true,
        });
    }
    }).catch((error) => {
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong!\n ' + error,
        showConfirmButton: true,
    });
    });
    },

  }}
</script>
<style>
thead.redTheme {
  background: rgb(145, 32, 32) !important;
}

thead.redTheme th {
  background: unset !important;
  color: white !important;
}

thead.redTheme tr:nth-child(2) th,
thead.redTheme tr:nth-child(3) th,
thead.redTheme tr:nth-child(4) th {
  background: rgb(163, 40, 40) !important;
}

thead.purpleTheme {
  background: rgb(95, 80, 110) !important;
}

thead.purpleTheme th {
  background: unset !important;
  color: white !important;
}

thead.purpleTheme tr:nth-child(2) th,
thead.purpleTheme tr:nth-child(3) th,
thead.purpleTheme tr:nth-child(4) th {
  background: rgb(133, 106, 161) !important;
}

thead.blueTheme {
  background: rgb(40, 62, 163) !important;
}

thead.blueTheme th {
  background: unset !important;
  color: white !important;
}

thead.blueTheme tr:nth-child(2) th,
thead.blueTheme tr:nth-child(3) th,
thead.blueTheme tr:nth-child(4) th {
  background: rgb(60, 79, 165) !important;
}

thead.yellowTheme {
  background: rgb(107, 96, 0) !important;
}

thead.yellowTheme th {
  background: unset !important;
  color: white !important;
}

thead.yellowTheme tr:nth-child(2) th,
thead.yellowTheme tr:nth-child(3) th,
thead.yellowTheme tr:nth-child(4) th {
  background: rgb(136, 138, 28) !important;
}

thead.orangeTheme {
  background: rgb(172, 95, 32) !important;
}

thead.orangeTheme th {
  background: unset !important;
  color: white !important;
}

thead.orangeTheme tr:nth-child(2) th,
thead.orangeTheme tr:nth-child(3) th,
thead.orangeTheme tr:nth-child(4) th {
  background: rgb(248, 152, 71) !important;
}

thead.greenTheme {
  background: rgb(0, 124, 56) !important;
}

thead.greenTheme th {
  background: unset !important;
  color: white !important;
}

thead.greenTheme tr:nth-child(2) th,
thead.greenTheme tr:nth-child(3) th,
thead.greenTheme tr:nth-child(4) th {
  background: rgb(0, 177, 81) !important;
}

th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}

tr.rowFooter {
  background: #acdfa8 !important;
}

tr.rowFooter td {
  background: unset !important;
}

.numberHover {
  cursor: pointer;
}

</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-12 text-end mb-3">
            <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailEvaluasi/` + id" class="btn btn-danger"><i class="fa fa-arrow-left"></i> <b>Kembali (Detail Nilai)</b></router-link>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                  <template v-slot:header>
                    <h5 class="my-0 text-primary">
                      <i class="mdi mdi-calendar-edit me-3"></i> Formulir
                      Perencanaan Pembelajaran
                    </h5>
                  </template>
                  <div class="card-body p-0">
                    <div class="row">
                      <div class="col-3">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Nomor Surat</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ nomor_surat }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Kode Pembelajaran</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ kode }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Dasar Pelaksanaan</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">
                              {{ dasar_pelaksanaan }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Judul Pembelajaran</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ judul }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Strategi</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ strategi }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Tipe Pembelajaran</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ learning_type }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">PIC</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ pic }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Angkatan</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ angkatan }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Pratikum</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ pratikum }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="font-size-12 mb-1">
                                <span class="text-dark">Durasi Hari Efektif (HE)</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">{{ durasi_he }}</p>
                              <hr style="margin:0 !important;">
                            </div>
                            <div class="col-12">
                              <h5 class="font-size-12 mb-1">
                                <span class="text-dark">Durasi Jam Pembelajaran (JP)</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">{{ durasi_jp }}</p>
                              <hr style="margin:0 !important;">
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="font-size-12 mb-1">
                                <span class="text-dark">Tanggal Mulai</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">
                                {{ tanggal_mulai }}
                              </p>
                              <hr style="margin:0 !important;">
                            </div>
                            <div class="col-12">
                              <h5 class="font-size-12 font-size-12">
                                <span class="text-dark">Tanggal Selesai</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">
                                {{ tanggal_selesai }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
              <div class="col-12">
                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                  <div class="card-body p-0">
                    <b-tabs pills justified content-class="p-3 text-muted">
                      <b-tab active class="border-0">
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="bx bx-user"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"><b>Individu</b></span>
                        </template>
                        <div class="row">
                          <TableNilaiIndividu @importNilai="importNilai" @exportNilai="exportNilaiAkademik" ref="TableNilaiIndividuRef" />
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="bx bx-user"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"><b>Quiz</b></span>
                        </template>
                        <div class="row">
                          <TableNilaiQuiz @importNilai="importNilai" @exportNilai="exportNilaiAkademik" ref="TableNilaiQuizRef" />
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="bx bx-user"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"><b>Kelompok</b></span>
                        </template>
                        <div class="row">
                          <TableNilaiKelompok @importNilai="importNilai" @exportNilai="exportNilaiAkademik" ref="TableNilaiKelompokRef" />
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="bx bx-user"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"><b>Substansi</b></span>
                        </template>
                        <div class="row">
                          <TableNilaiSubstansi @importNilai="importNilai" @exportNilai="exportNilaiAkademik" ref="TableNilaiSubstansiRef"/>
                        </div>
                      </b-tab>

                    </b-tabs>
                  </div>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <b-modal v-model="showModal.importNilai" title="Import Nilai " title-class="text-black font-18" body-class="p-3" hide-footer>
    <form @submit.prevent="storeImportNilai()">
      <div class="row mt-2">
        <div class="col-12 text-end">
          <a :href="templateExcel" target="_blank" class="btn btn-sm btn-success" style="border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
            <i class="fas fa-download"></i>
            &nbsp;
            <span><b>Download Template</b></span>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <input type="file" class="form-control" id="inputExcelNilai" placeholder="Masukkan File Excel . . ." v-on:change="inputFileExcelNilai()" accept=".xlsx" style="border-top-right-radius: 0px !important;">
        </div>
        <div class="col-12">
          <div class="respond-input-file float-left" id="uploadLoadingNilai"></div>
        </div>
      </div>

      <div class="row mt-3 mb-2">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end">
          <b-button variant="primary" type="submit">
            <i class="fas fa-check"></i>
            &nbsp;
            <span><b>Simpan</b></span>
          </b-button>
        </div>
      </div>
    </form>
  </b-modal>

</template>



